import * as React from 'react'

import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'

import UserAvatar from 'modules/core/components/UserAvatar'
import i18n from 'modules/core/lib/i18n'
import type User from 'modules/core/store/models/User'

import MeAnonymousLabel from 'modules/surveys/components/Participants/common/MeAnonymousLabel'

function PlaceholderLabel() {
  return (
    <Box>
      <Box flexDirection="row" gap="s16" alignItems="center">
        <Avatar label={i18n.t('common.anonymous_user')} />
        <Text.Normal>{i18n.t('common.anonymous_user')}</Text.Normal>
      </Box>
    </Box>
  )
}

interface UserProps {
  user: User
  description?: string | null | undefined
}

function UserLabel({ user, description }: UserProps) {
  return (
    <>
      <UserAvatar user={user} size="s40" />
      <Box justifyContent="center">
        <Text.Normal size="300" weight="medium">
          {user.fullName()}
        </Text.Normal>
        {description && (
          <Text.Normal size="200" color="grey800">
            {description}
          </Text.Normal>
        )}
      </Box>
    </>
  )
}

interface Props {
  description?: string | null | undefined
  user?: User | null | undefined
  isAnonymous?: boolean
}

const UserBlock = ({
  children,
  description,
  user,
  isAnonymous,
}: React.PropsWithChildren<Props>) => (
  <Box
    overflowY="hidden"
    overflowX="hidden"
    borderRadius={{
      all: 'abs008',
    }}
    border={{
      all: {
        style: 'solid',
        width: 's1',
        color: 'grey400',
      },
    }}
  >
    <Box
      background="grey000White"
      flexDirection="row"
      paddingX="s16"
      paddingY="s24"
      gap="s16"
      border={{
        bottom: {
          style: 'solid',
          width: 's1',
          color: 'grey400',
        },
      }}
    >
      {user &&
        (isAnonymous ? (
          <MeAnonymousLabel user={user} />
        ) : (
          <UserLabel user={user} description={description} />
        ))}
      {!user && <PlaceholderLabel />}
    </Box>
    <Box
      background="grey100"
      borderRadius={{
        bottomRight: 'abs008',
        bottomLeft: 'abs008',
      }}
    >
      {children}
    </Box>
  </Box>
)

export default UserBlock
